import $ from 'jquery';
import throttle from 'lodash.throttle';
import LazyImages from '../../../components/lazy-images';
export default class AjaxLoadMore {
    static selector;
    static loadMoreBtnSelector;
    static showLessBtnSelector;
    static initialContainer;
    static init(selector) {
        const $wrapper = $(selector);
        const $window = $(window);
        const $container = $wrapper.find('.js__ajax-load-more-container');
        this.selector = selector;
        this.loadMoreBtnSelector = '.js__load-more-btn';
        this.showLessBtnSelector = '.js__show-less-btn';
        this.initialContainer = $container.html();
        if ($wrapper.data('lazy-load')) {
            const wrapperTopPosition = $wrapper.position().top;
            $window.on('scroll', throttle(() => {
                const wrapperHeight = $wrapper.height() || 0;
                const wrapperBottomPosition = wrapperTopPosition + wrapperHeight;
                const windowHeight = $window.height() || 0;
                const windowScrollDistance = $window.scrollTop() || 0;
                const loadInitBottomOffset = 200;
                const isBottomOfSection = wrapperBottomPosition <= windowHeight + windowScrollDistance + loadInitBottomOffset;
                if (isBottomOfSection) {
                    this.loadMore($('.js__ajax-load-more-loader'));
                }
            }, 300));
        }
        $(selector).on('click', this.loadMoreBtnSelector, e => {
            e.preventDefault();
            const $button = $(e.currentTarget);
            this.loadMore($button);
        });
        $(selector).on('click', this.showLessBtnSelector, e => {
            const $button = $(e.currentTarget);
            this.showLess($button);
        });
    }
    static showLess($button) {
        const $wrapper = $button.closest(this.selector);
        const $container = $wrapper.find('.js__ajax-load-more-container');
        const $loadMoreBtn = $button.closest(this.selector).find(this.loadMoreBtnSelector);
        const scrollOffset = 55;
        const navBarHeight = $('.js___navbar').height() || 0;
        const navBarSubMenuHeight = $('.js__navbar-sub-menu').height() || 0;
        $wrapper.data('page', 2);
        $loadMoreBtn.removeClass('d-none');
        $wrapper.find('.js__content-hidden-with-ajax-btn').removeClass('d-none');
        $button.addClass('d-none');
        $container.html(this.initialContainer);
        window.scrollTo(0, $wrapper.position().top - navBarHeight - navBarSubMenuHeight - scrollOffset);
    }
    static loadMore($loaderContainer) {
        const $wrapper = $loaderContainer.closest(this.selector);
        const $container = $wrapper.find('.js__ajax-load-more-container');
        const $showLessBtn = $wrapper.find(this.showLessBtnSelector);
        const page = $wrapper.data('page');
        const pageCount = $wrapper.data('page-count');
        const url = $loaderContainer.closest(this.selector).data('url');
        const buttonText = $loaderContainer.html();
        const loader = '<span class="spinner-border text-primary-new" role="status" aria-hidden="true"></span>';
        if (url && pageCount >= page && !$wrapper.data('loading')) {
            $loaderContainer.html('');
            $loaderContainer.prepend(loader);
            $loaderContainer.prop('disabled', true);
            $wrapper.data('loading', true);
            $.get(`${url}?page=${page}`, html => {
                $wrapper.data('loading', false);
                $showLessBtn.removeClass('d-none');
                $loaderContainer.prop('disabled', false);
                $loaderContainer.html(buttonText);
                $container.append(html);
                LazyImages.update();
                if (pageCount < page + 1) {
                    $loaderContainer.addClass('d-none');
                    $wrapper.find('.js__content-hidden-with-ajax-btn').addClass('d-none');
                }
                $wrapper.data('page', page + 1);
            }).fail(() => {
                $wrapper.data('loading', false);
                $loaderContainer.prop('disabled', false);
                $loaderContainer.html(buttonText);
            });
        }
    }
}
